import { getTheme, IButtonStyles } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPIconButton } from 'baseComponents';
import { IPPersona, IPPersonaSize } from 'baseComponents/Persona/IPPersona';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { cancelIcon, globalStackTokensGapExtraSmall } from 'globalStyles';
import User from 'models/user';
import { useContext } from 'react';

interface IUserTagProps {
  user: User;
  compact?: boolean;
  hideBackground?: boolean;
  textColor?: string;
  onRemove?: (item: User) => void;
}

const UserTag = (props: IUserTagProps) => {
  const appContext = useContext(AppContext);
  const theme = getTheme();
  const size = props.compact ? IPPersonaSize.size24 : IPPersonaSize.size40;

  const tagButtonStyles: IButtonStyles = {
    root: {
      borderRadius: '10px',
      height: props.compact ? '24px' : '40px',
      width: props.compact ? '24px' : '40px',
    },
  };

  return (
    <IPStack
      horizontal
      tokens={globalStackTokensGapExtraSmall}
      verticalAlign="center"
      styles={
        props.hideBackground !== true
          ? {
              root: {
                background: appContext.useDarkMode ? theme.palette.neutralSecondary : theme.palette.neutralLight,
                borderRadius: '10px',
                height: 1 + (props.compact ? 24 : 40),
              },
            }
          : undefined
      }
    >
      <IPStack.Item>
        <IPPersona
          imageUrl={props.user.getPhotoURLObj()}
          text={props.user.name}
          secondaryText={props.user.email}
          size={size}
          hidePersonaDetails={false}
          styles={{ primaryText: { color: props.textColor } }}
        />
      </IPStack.Item>
      {props.onRemove && (
        <IPStack.Item>
          <IPIconButton
            onClick={() => {
              if (props.onRemove) {
                props.onRemove(props.user);
              }
            }}
            styles={tagButtonStyles}
            iconProps={cancelIcon}
          />
        </IPStack.Item>
      )}
    </IPStack>
  );
};

export default UserTag;
